<script>
import OrdersApi from "@/services/orders-api";
import AvoirRequestApi from "@/services/avoirRequest-api";
import AvoirLineEntry from "@/components/AvoirLineEntry";
import VueBarcode from 'vue-barcode';

export default {

  components: {
     VueBarcode,
     AvoirLineEntry
  },

  props: {
    onClose:{
      type:Function,
      default: null
    }, 
    title:{
      type:String,
      default: ""
    },

    showAddNewAvoirModal:{
      type:Boolean,
      default: false
    },
    isNew:{
      type:Boolean,
      default: false
    },

    propsAvoirId:{
      type:Number,
      default: null
    },

    isSearchAvoirItemWithBarcodeScannerEnabled: Boolean
  },

  data() {
    return {
        localShowAddNewAvoirModal: this.showAddNewAvoirModal,

        pagemodel: {currentPage : 1, perPage : 10, totalRows: 0},

        ordersList: [],
        isTableLoading: false,

        orderSelected:null,
        orderLineSelected:null,
        avoir:{} ,
        avoirLines:{} ,

        start:null ,
        end:null ,
        orderLines: [] ,
        quantityAvoir:0 ,
        confirmedQuantityAvoir:0 ,
        reason:null ,
        avoirRequestId:null ,
        selectedItem: { },
        batchDate:"",
        expirationDate:"",
        blNumber:"",
        batchNumber:"",
        showItemsModal:false ,
        itemsFilter: '',
        pagemodelMain: {currentPage : 1, perPage : 15, totalRows: 0},
        isItemsTableBusy: false,
        endOfFindItems:false,
        itemsList: [],
        itemLines: [],
        itemFields: [
        {key:"actions", label:""},
        { key:"ref", label: "Réference", sortable: false, tdClass:"text-left align-middle"},
        { key:"title", label: "Article", sortable: false, tdClass:"text-left font-weight-bold  align-middle"},
        { key:"packageCount", label:"Unités par carton", thClass:"text-right", tdClass:"text-right align-middle", thStyle:"width:150px;"}, 
        { key:"priceTaxIncl", label:"Prix TTC", thClass:"text-right ", tdClass:"text-right font-weight-bold align-middle", thStyle:"width:100px;"}, 
        
        // { key:"price", label: "P.U (TND)", sortable: false, tdClass:"text-right font-weight-bold", thClass:"text-right", thStyle:"width:150px"},
        // { key:"discount", label: "remise (TND)", sortable: false, tdClass:"text-right font-weight-bold", thClass:"text-right", thStyle:"width:150px"},
        // { key:"discountedPrice", label: "P.U.Remisé (TND)", sortable: false, tdClass:"text-right font-weight-bold", thClass:"text-right", thStyle:"width:100px"},
      ],
        //item:null,
        isAddingLine: false,

    };
  },

  mounted(){

    //this.getOrders()

    var date = new Date();
      
      this.start = new Date(date.getFullYear(), date.getMonth(), 1);
      const startoffset = this.start.getTimezoneOffset()
      this.start= new Date(this.start.getTime() - (startoffset*60*1000))
      this.start=this.start.toISOString().split('T')[0]

      this.end = new Date(date.getFullYear(), date.getMonth() + 1, 0);
      const endoffset = this.end.getTimezoneOffset()
      this.end= new Date(this.end.getTime() - (endoffset*60*1000))
      this.end=this.end.toISOString().split('T')[0]
  },
  
  computed: {
        role() {
          return this.$cookies.get('userr');
        },

        linesCount() {
          return Array.isArray(this.avoirLines) ? this.avoirLines.length : 0
        },


        canDeleteLines() {
          return this.role==0 && (this.avoir.status==0 || this.avoir.status==1)
        },

        isMSS() {
          return process.env.VUE_APP_CLIENT_NAME === "mss"
        },

        shouldShowBatchFields() {
          return !this.isMSS
        },

        linesColumnCount() {
          return (this.shouldShowBatchFields ? 5 : 3) + (this.ischeckBlNumberAvoir ? 1 : 0) + (this.isAvoirWithExpirationDateEnabled ? 1 : 0) + (this.canDeleteLines ? 1 : 0)
        },


        isAvoirWithExpirationDateEnabled(){
          return  process.env.VUE_APP_FEATURE_AVOIR_WITH_EXPIRATION_DATE === 'true'
        },

        ischeckBlNumberAvoir(){
          return  process.env.VUE_APP_FEATURE_CHECK_BL_NUMBER_AVOIR === 'true'
        },
        
    },

  methods: {


    onShown() {
      if (this.isSearchAvoirItemWithBarcodeScannerEnabled) {
        this.$nextTick(() => {
          this.$refs.lineEntry && this.$refs.lineEntry.focusItem();
        });
      }
    },

    printModal() {
      this.applyPrintStylesForModal();
      this.$nextTick(() => {
        window.print();
      });
    },
    applyPrintStylesForModal(modalSelector = '.avoir-printable-modal') {
      const style = document.createElement('style');
      style.id = 'print-modal-style';

      style.textContent = `
        @media print {
          body {
            margin: 0 !important;
            padding: 0 !important;
            top: 0 !important;
            left: 0 !important;
            background: white !important;
            overflow: visible !important;
            -webkit-print-color-adjust: exact;
          }
          body * {
            visibility: hidden !important;
          }
          ${modalSelector}, ${modalSelector} * {
            visibility: visible !important;
          }
        }
      `;

      document.head.appendChild(style);

      function cleanup() {
        if (style.parentNode) {
          style.parentNode.removeChild(style);
        }
        window.removeEventListener('afterprint', cleanup);
      }

      window.addEventListener('afterprint', cleanup);
    },




    onCloseAddNewAvoirModal(){
      this.selectedItem = {};
      this.batchNumber=""
      this.batchDate=""
      this.expirationDate=""
      this.blNumber=""
      this.onClose()
      if(this.role == 0 && this.avoirRequestId ){
        AvoirRequestApi.deleteAvoirRequestIfEmpty(this.avoirRequestId ).then(
          this.onClose()
        )
      }else{
        this.onClose()
      }
    }, 

    refusedAvoirRequest(){
      const status = 3 ;
      AvoirRequestApi.addRequestAvoir(this.avoirRequestId  , null , status )
        .then(avoirId => {
            if(avoirId) {
            this.avoirRequestId = avoirId 
            this.onCloseAddNewAvoirModal()
            }
          })
    },

    validateRequest(){
      AvoirRequestApi.validateRequestAvoir(this.avoir )
      .then(()=>{
        this.onCloseAddNewAvoirModal()
            })
    },

    requestAvoirStatusToLabel(status){
      switch(status){
        case 0: return 'Brouillon';
        case 1: return 'Envoyée';
        case 2:return 'Traitée';
        case 3 :return 'Refusée';
        default: return '_'
      }
    },

    requestAvoirToColor(status){
      switch(status){
        case 0: return 'secondary';
        case 1: return 'warning';
        case 2:return 'success';
        case 3 :return 'danger';
        default: return '_'
      }
    },

    sendNewAvoir(){
      const status = 1
          AvoirRequestApi.addRequestAvoir(this.avoirRequestId  , this.reason , status )
        .then(avoirId => {
            if(avoirId) {
              this.avoirRequestId = avoirId
              this.getRequestAvoirById()
            }
          }) 
        },
 
    addRequestAvoirLine(line){
      const lineAvoirRequest = {
                avoirId: this.avoirRequestId,
                itemId: line.item.id,
                quantityAvoir: line.quantityAvoir,
                reason: line.reason,
                batchNumber: line.batchNumber,
                batchDate: line.batchDate,
                expirationDate: line.expirationDate,
                blNumber: line.blNumber,
      };

      this.isAddingLine = true
      AvoirRequestApi.addRequestAvoirLine(lineAvoirRequest )
          .then((avoirId)=>{
            if (avoirId) {
              this.avoirRequestId = avoirId
              this.getRequestAvoirById()
              this.$refs.lineEntry && this.$refs.lineEntry.reset()
            }
          })
          .finally(() => { this.isAddingLine = false })
    } , 

    removeAvoirLine(line){
        const lineAvoirRequest = {
                    avoirId: this.avoirRequestId,
                    itemId: line.itemId ,
                    quantityAvoir:line.quantityAvoir,
        };
        AvoirRequestApi.deleteAvoirRequestLine(lineAvoirRequest )
        .then(()=>{
            this.getRequestAvoirById()
        } )
    }, 

    getOrderLines(orderId){
      OrdersApi.getOrderLines(orderId).then(
      order => {
          if (order){
          this.orderLines=order.lines
          }}
      )
    },

    getRequestAvoirById(){
      AvoirRequestApi.getRequestAvoirById(this.avoirRequestId  ).then(
        result => {
            if (result){

            this.avoir=result
            this.reason = result.reason
            this.avoirLines =result.lines ?  result.lines : []
            } }
        )
    },

    getOrders() {
      this.isTableLoading = true
      
      if(this.role==0){
        const status = 3 ;

      OrdersApi.getOrdersByCustomer(this.pagemodel.currentPage, this.pagemodel.perPage,this.supplierId, false,status,this.isCurrent,this.start,this.end, this.channel ,true)
      .then(orders => {
        if(orders){
          this.ordersList =orders.list ;
          this.pagemodel.totalRows = orders.total;
          this.pagemodel.currentPage = orders.page;
          this.pagemodel.perPage = orders.pageSize;
          this.pagemodel.pageSize = orders.pageSize;
        }
      })
      .finally(() => {
        this.isTableLoading=false 
      })
      }
    }, 
  },

  watch: {
    // invoices-list creates this modal only when it opens (v-if), so this must also run on creation:
    // otherwise an existing request opens empty, because its lines are loaded here
    showAddNewAvoirModal: {
      immediate: true,
      handler(isOpen) {
      this.avoirRequestId = this.propsAvoirId
      this.localShowAddNewAvoirModal = isOpen;
      this.orderSelected = null
      if (this.isNew){
        this.reason=null
      }
      this.avoirLines ={}
      if(isOpen && this.avoirRequestId){
        this.getRequestAvoirById(this.avoirRequestId)
      }
      
      },
    }, 

    end: function(){
          if((this.end  && this.start) || (!this.end  && !this.start) ){
            this.getOrders()
          }   
    },
    start: function(){
        if((this.end && this.start) || (!this.end  && !this.start)  ){
          this.getOrders()
        }
    },

    orderSelected: function(){
        this.orderLineSelected = null;
        if (this.orderSelected){       
            this.getOrderLines(this.orderSelected.id);
            this.quantityAvoir = 0
        }    
    }, 

    orderLineSelected: function(){
      if (this.orderLineSelected){       
          this.quantityAvoir = 0
      }    
    },
  },
  
};
</script>

<template>

<b-modal
  :modal-class="'avoir-printable-modal'"
  v-model="localShowAddNewAvoirModal"
  :title="this.title" 
  title-class="text-primary"
  title-tag="h5"
  header-close-variant="danger"
  size="xl"
  no-close-on-backdrop
  @hide="onCloseAddNewAvoirModal"      
  hide-footer
  ref="itemModal"
  @shown="onShown"

  >

    <div class="d-none d-print-block mb-4">
        <div class="row">
          <div class="col-6">
            <span >
              <h6 class="font-size-18 mt-4"><span class="font-weight-bold">Nom du client : </span><span>{{this.avoir.customer}}</span></h6>
            </span>
            <span>
              <h6 class="font-size-18 mt-4"><span class="font-weight-bold">Adresse : </span><span>{{this.avoir.customerAddress == null ? "" : this.avoir.customerAddress}}</span></h6>
            </span>
            <span>
              <h6 class="font-size-18 mt-4"><span class="font-weight-bold">Matricule Fisale : </span><span>{{this.avoir.customerTaxRefNumber == null ? "..................................................................." : this.avoir.customerTaxRefNumber }}</span></h6>
            </span>

          </div>

          <div class="col-6 text-right">
            <vue-barcode
              v-if="avoir.avoirId"
                  :value="avoir.avoirId"
                  :width="2"  :height="50" 
                  background="transparent"
                  fontSize="16" >
                </vue-barcode>

          </div>

        </div>

        <div class="row">
          <div class="col-12 text-right">
            <span>
              <h6 class="font-size-18 mt-5"><span class="font-weight-bold">Date : </span><span>{{this.avoir.date}}</span></h6>
            </span>
          </div>
        </div>
        
        <div class="text-center mt-5 mb-5">
          <h3 class="font-weight-bold mt-2">BON DE RETOUR N° <span>{{avoir.avoirId}}</span></h3>
        </div>

          <div class="row">
          <div class="col-12 ">
            <span>
              <h6 class="font-size-18 mt-4"><span class="font-weight-bold">Fournisseur : </span><span>{{this.avoir.supplier == null ? "" : this.avoir.supplier}}</span></h6>
            </span>
            <span>
              <h6 class="font-size-18 mt-4"><span class="font-weight-bold">Matricule Fisale : </span><span>{{this.avoir.supplierTaxRefNumber == null ? "" : this.avoir.supplierTaxRefNumber }}</span></h6>
            </span>
            <span>
              <h6 class="font-size-18 mt-4"><span class="font-weight-bold">Nom du chauffeur : </span><span>...................................................................</span></h6>
            </span>
          </div>
        </div>
        


    </div>

    <!-- summary: number, date, status, client -->
    <div v-if="avoir && avoir.avoirId" class="avoir-req__summary d-print-none">
      <div class="avoir-req__summary-item">
        <span class="avoir-req__summary-label">Demande N°</span>
        <span class="avoir-req__summary-value">{{ avoir.avoirId }}</span>
      </div>
      <div v-if="avoir.date" class="avoir-req__summary-item">
        <span class="avoir-req__summary-label">Date</span>
        <span class="avoir-req__summary-value">{{ avoir.date }}</span>
      </div>
      <div v-if="role==1 && avoir.customer" class="avoir-req__summary-item">
        <span class="avoir-req__summary-label">Client</span>
        <span class="avoir-req__summary-value">{{ avoir.customer }}</span>
      </div>
      <div class="avoir-req__summary-item">
        <span class="avoir-req__summary-label">Articles</span>
        <span class="avoir-req__summary-value">{{ linesCount }}</span>
      </div>
      <div class="avoir-req__summary-item">
        <span class="avoir-req__summary-label">État</span>
        <span><b-badge :variant="requestAvoirToColor(avoir.status)" class="font-size-12">{{ requestAvoirStatusToLabel(avoir.status) }}</b-badge></span>
      </div>
    </div>

    <!-- new line -->
    <AvoirLineEntry v-if="isNew || (this.role==0 && avoir.status==0)" ref="lineEntry" class="d-print-none" :busy="isAddingLine"
      :showBlNumber="ischeckBlNumberAvoir" :showExpirationDate="isAvoirWithExpirationDateEnabled"
      :barcodeScanner="isSearchAvoirItemWithBarcodeScannerEnabled" @add="addRequestAvoirLine" />

    <!-- lines -->
    <div class="avoir-req__lines-title d-print-none">
      <h6 class="mb-0 font-weight-bold text-dark">Articles de la demande</h6>
      <span class="text-muted font-size-13">{{ linesCount }} ligne{{ linesCount > 1 ? 's' : '' }}</span>
    </div>
    <div class="table-responsive avoir-req__table-wrap">
        <table class="table print-table-this avoir-req__lines">
          <thead>
            <tr>
              <th v-if="ischeckBlNumberAvoir">Num BL</th>
              <th>Article</th>
              <th v-if="shouldShowBatchFields">Num Lot</th>
              <th v-if="shouldShowBatchFields">Date Lot</th>
              <th v-if="isAvoirWithExpirationDateEnabled">Date péremption</th>
              <th class="text-right">Qté</th>
              <th>Motif de la demande</th>
              <th v-if="canDeleteLines" class="d-print-none" style="width:60px;"></th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="!linesCount" class="d-print-none">
              <td :colspan="linesColumnCount" class="avoir-req__empty">
                <i class="fas fa-box-open"></i>
                Aucun article dans cette demande.
                <span v-if="isNew || (this.role==0 && avoir.status==0)">Ajoutez un article avec le formulaire ci-dessus.</span>
              </td>
            </tr>
            <tr v-for="(line,i) in this.avoirLines" :key="i">
              <td v-if="ischeckBlNumberAvoir">{{ line.blNumber }}</td>
              <td>
                <div class="font-weight-bold">{{line.itemTitle}}</div>
                <span class="font-size-12 text-muted">Réf : {{ line.itemRef }}</span>
              </td>
              <td v-if="shouldShowBatchFields">{{ line.batchNumber }}</td>
              <td v-if="shouldShowBatchFields" class="text-nowrap">{{ line.batchDate }}</td>
              <td v-if="isAvoirWithExpirationDateEnabled" class="text-nowrap">{{ line.expirationDate }}</td>
              <td class="text-right avoir-req__qty">{{ line.quantityAvoir }}</td>
              <td>{{ line.reason }}</td>
              <td v-if="canDeleteLines" class="text-center d-print-none">
                <b-button size="sm" variant="outline-danger" title="Supprimer la ligne" @click="removeAvoirLine(line)">
                  <i class="mdi mdi-trash-can font-size-16"></i>
                </b-button>
              </td>
            </tr>
          </tbody>
        </table>
    </div>


    <div class="row mt-5 d-none d-print-block">
      <div class="col-12 text-right">
        <span>
          <h6 class="font-size-18 mt-5 font-weight-bold">Cachet et Signature</h6>
        </span>
      </div>
    </div>

    <div class="avoir-req__footer d-print-none">
      <div class="avoir-req__hint">
        <span v-if="role==0 && avoir && avoir.status === 0">
          <i class="mdi mdi-information-outline mr-1"></i>Demande enregistrée en brouillon : cliquez sur « Envoyer la demande » pour la transmettre.
        </span>
      </div>
      <div class="avoir-req__actions">
        <b-button variant="outline-secondary" v-if="avoir && avoir.status" @click="printModal">
          <i class="fa fa-print font-size-14 align-middle mr-2"></i>{{$t("order.buttons.print")}}
        </b-button>

        <b-button variant="success" @click="sendNewAvoir" v-if="role==0 && avoir && avoir.status === 0" :disabled="!linesCount">
          <i class="fas fa-paper-plane font-size-14 align-middle mr-2"></i><span class="font-weight-bold">Envoyer la demande</span>
        </b-button>

        <b-button variant="success" @click="validateRequest" v-if="role==1 && avoir && avoir.status != 2">
          <i class="fas fa-check-circle font-size-14 align-middle mr-2"></i><span class="font-weight-bold">Clôturer</span>
        </b-button>
      </div>
    </div>



</b-modal>
</template>
<style>
@media print {
  .table-responsive {
    overflow: visible !important;
  }
  .print-table-this th,
  .print-table-this td {
    border: 1px solid black !important;
    border-collapse: collapse !important;
    color: black;
  }
  .print-table-this{
    color: black;
    page-break-inside: auto;
  }
  h3,h6{
    color: black;
  }
  span{
    color: black;
  }
  .print-table-this tr {
    page-break-inside: avoid;
    page-break-after: auto;
  }

  .print-table-this thead {
    display: table-header-group;
  }

  .print-table-this tbody {
    display: table-row-group;
  }


  .avoir-printable-modal {
    position: relative !important;
    top: 0 !important;
    left: 0 !important;
    width: 100vw !important; 
    min-width: 100% !important;
    max-width: 100% !important;
    height: 100vh !important;
    min-height: 100vh !important;
    max-height: 100vh !important;
    background: white !important;
    padding: 0 !important;
    margin-bottom: 20px !important;
    overflow: visible !important;
    z-index: 9999 !important;
  }

  .avoir-printable-modal .modal,
  .avoir-printable-modal .modal-dialog,
  .avoir-printable-modal .modal-content {
    position: static !important;
    top: 0 !important;
    left: 0 !important;
    transform: none !important;
    width: 100% !important;
    max-width: 100% !important;
    margin-bottom: 20px !important;
    padding: 0 !important;
    box-shadow: none !important;
    background-color: white !important;
  }

  .avoir-printable-modal .modal-backdrop {
    display: none !important;
  }
  .avoir-printable-modal,
  .avoir-printable-modal * {
    visibility: visible;
  }

}
</style>
<style src="./avoir-request.css"></style>
